module.exports = __webpack_public_path__ + "static/img/1.f54ad27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/1.png
// module id = /A/x
// module chunks = 0